export default "__VITE_ASSET__B7BhR2FC__"